module.exports = __webpack_public_path__ + "static/media/del.082519b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/del.svg
// module id = 10
// module chunks = 1